import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { AustraliaMap, NewZealandMap } from "../../../components/shared";
import { REIButton, REIDialoge, REIDivider, REIErrorMessage, REISelectButton } from "../../../components/ui";

import { ISaveSearch } from "../../../interface/ISaveSearch";
import { clearFilterValue, resetSalesListingData } from "../../../store/slice/investarSearchSlice";

import LocationComponent from "../../SavedSearch/Edit/Child/LocationComponent";
import PropertyTypeComponent from "../../SavedSearch/Edit/Child/PropertyTypeComponent";
import StrategyComponent from "../../SavedSearch/Edit/Child/StrategyComponent";
import SuburbComponent from "../../SavedSearch/Edit/Child/SuburbComponent";

import { ApiEndPoints } from "../../../utils/endpoints";
import { httpPost, useHttpGet } from "../../../services/httpService";
import { COUNTRY, COUNTRY_OPTIONS, LOCATION_ADVANCED, OPTION_ALL } from "../../../utils/constants";

import SaveThisSearch from "./saveThisSearch";
import { RootState } from "../../../store";
import { classNames } from "primereact/utils";
import { AUS_MAP_DATA, NZ_MAP_DATA } from "../../../utils/mapdata";
import { updateSearchState, setIsFilterApplied, setLiveSearchObject } from "../../../store/slice/searchStateSlice";

interface ISearchDetailProps {
  handleSearchClick: (data: {}, filters: {}) => void;
  resetSearchOnlyScreen: () => void;
  searchOnlyScreen?: boolean;
  setSearchLoading: () => void;
}

const SearchDetail: React.FC<ISearchDetailProps> = ({
  handleSearchClick,
  resetSearchOnlyScreen,
  searchOnlyScreen,
  setSearchLoading,
}) => {
  const [country, setCountry] = useState(1);
  const [currentCountry, setCurrentCountry] = useState(COUNTRY.AU);
  const [currentState, setCurrentState] = useState(null);
  const [refreshData] = useState(true);
  const [showMap, setShowMap] = useState(false);

  const [showSaveThisSearch, setShowSaveThisSearch] = useState<boolean>(false);

  interface SelectedDropdownValueType {
    locationtags?: string[];
    selectedRegion?: number;
    selectedDistrict?: number;
    locationSearchType?: number;
    locationAdanced?: any;
    locationBasicsSuburbs?: string[];
    suburbs?: any[];
    orderBy?: string;
    keywordStrategies?: number;
    keywordPhrase?: number;
    excKeywordPhrase?: number;
    keywordPhrases?: string;
    excKeywordPhrases?: string;
    dwellingTypes?: number;
    priceRangeMin?: number;
    priceRangeMax?: number;
    bedRoomsMin?: number;
    bedRoomsMax?: number;
    bathRoomsMin?: number;
    bathRoomsMax?: number;
    carportsMin?: number;
    carportsMax?: number;
    landSizesMin?: number;
    landSizesMax?: number;
    listingAgeMin?: number;
    listingAgeMax?: number;
    propertyYieldMin?: number;
    propertyYieldMax?: number;
    includeLand?: boolean;
    filterRangeMin?: number;
    filterRangeMax?: number;
    suburbMedianRangeMin?: number;
    suburbMedianRangeMax?: number;
    suburbListingRangeMin?: number;
    suburbListingRangeMax?: number;
    suburbGrowthRangeMin?: number;
    suburbGrowthRangeMax?: number;
    populationMin?: number;
    populationMax?: number;
    daysOnMarketMin?: number;
    daysOnMarketMax?: number;
    vacancyRateMin?: number;
    vacancyRateMax?: number;
    valueInitiated?: boolean;
    postcodeRadiusFrom?: string;
    postcodeRadiusTo?: string;
    ofPostcode?: string;
    suburbRadiusFrom?: string;
    suburbRadiusTo?: string;
    OflimitSuburb?: string;
    selectedSuburbType?: string;
  }

  const [selectedDropdownValue, setSelectedDropdownValue] = useState<SelectedDropdownValueType>({});
  const [keywords, setKeywords] = useState(null);
  const [strategyKeywords, setStrategyKeywords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchData, setSearchData] = useState<ISaveSearch>(null);
  const [locationValidationError, setLocationValidationError] = useState<boolean>(false);
  const salesListingData = useSelector((state: RootState) => state.investar.salesListingData);

  const dispatch = useDispatch();
  const filterData = useSelector((state: RootState) => state.investar.filterValue);
  const searchId = useSelector((state: RootState) => state.investar.searchId);
  const sortBy = useSelector((state: RootState) => state.investar.sortBy);
  const [resetAllFilters, setResetAllFilters] = useState(false);
  const [isClikedReset, setIsClikedReset] = useState(false);

  const { data: options, error } = useHttpGet(`${ApiEndPoints.parameter}/LocalityFilters/AU`, undefined, refreshData);

  useEffect(() => {
    if (filterData && filterData.Country.OrderBy != sortBy?.toString() && selectedDropdownValue) {
      selectedDropdownValue.orderBy = sortBy?.toString();
      !salesListingData && searchResult();
    }
  }, [sortBy]);

  useEffect(() => {
    if (options) {
      initializeFormData();
    }
  }, [options]);

  useEffect(() => {
    if (searchId > 0) {
      initializeFormData();
      var searchValue = {
        Country: { ...filterData.Country },
        Locality: [...filterData.Locality],
      };
      searchValue.Country.Title = "";
      searchValue.Country.MemberID = localStorage.getItem("member_id") || "";

      httpPost(`${ApiEndPoints.searchSummary}/${currentCountry}/Search/Summary/`, searchValue)
        .then((result) => {
          if (result.status == 200) {
            handleSearchClick(result?.data, filterData);
          }
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
        });
    }
  }, [searchId]);

  useEffect(() => {
    const openSaleslisting = async () => {
      if (salesListingData) {
        initializeFormData();
        const filers = await getSearchObject();
        handleSearchClick(salesListingData, filers);

        setTimeout(() => {
          dispatch(resetSalesListingData());
        }, 3000);
      }
    };
    if (salesListingData) {
      openSaleslisting();
    }
  }, [salesListingData]);

  useEffect(() => {
    if (!options || !selectedDropdownValue?.valueInitiated) {
      return;
    }

    if (isClikedReset) dispatch(setIsFilterApplied(false));
    else dispatch(setIsFilterApplied(hasNonDefaultFilter()));

    let active = true;
    getSearchObject().then((obj) => {
      if (active) {
        dispatch(setLiveSearchObject(obj));
      }
    });
    setIsClikedReset(false);
    return () => {
      active = false;
    };
  }, [selectedDropdownValue, currentState, strategyKeywords, currentCountry, options]);

  const getDefaultDropdownValues = () => {
    return {
      priceRangeMin: options?.PropertySpecifics?.PriceRange.PriceRangeMin[0].ListingPrice_From_ID,
      priceRangeMax: options?.PropertySpecifics?.PriceRange.PriceRangeMax[0].ListingPrice_To_ID,
      keywordStrategies: options?.Strategy?.Strategies[0].FilterStrategyID,
      keywordPhrase: options?.Strategy?.KeywordPhrase[0].FilterKeywordSearchTypeID,
      excKeywordPhrase: options?.Strategy?.ExcKeywordPhrase[0].FilterExcludeKeywordSearchTypeID,
      dwellingTypes: options?.PropertySpecifics?.DwellingTypes[0].FilterDwellingTypeID,
      bedRoomsMin: options?.PropertySpecifics?.BedRooms.BedRoomsMin[0].Bedroom_From_ID,
      bedRoomsMax: options?.PropertySpecifics?.BedRooms.BedRoomsMax[0].Bedroom_To_ID,
      bathRoomsMin: options?.PropertySpecifics?.BathRooms.BathRoomsMin[0].Bathroom_From_ID,
      bathRoomsMax: options?.PropertySpecifics?.BathRooms.BathRoomsMax[0].Bathroom_To_ID,
      carportsMin: options?.PropertySpecifics?.Carports.CarportsMin[0].Carport_From_ID,
      carportsMax: options?.PropertySpecifics?.Carports.CarportsMax[0].Carport_To_ID,
      landSizesMin: options?.PropertySpecifics?.LandSizes.LandSizesMin[0].LandSize_From_ID,
      landSizesMax: options?.PropertySpecifics?.LandSizes.LandSizesMax[0].LandSize_To_ID,
      listingAgeMin: options?.ListingDetails?.ListingAge?.ListingAgeMin[0].ListingAge_From_ID,
      listingAgeMax: options?.ListingDetails?.ListingAge?.ListingAgeMax[0].ListingAge_To_ID,
      propertyYieldMin: options?.ListngDetails?.PropertyYields.PropertyYieldMin[0].PotentialYield_From_ID,
      propertyYieldMax: options?.ListingDetails?.PropertyYields.PropertyYieldMax[0].PotentialYield_To_ID,
      filterRangeMin: options?.SuburbStatistics?.RentalYields.FilterRangeMin[0].From_ID_Int,
      filterRangeMax: options?.SuburbStatistics?.RentalYields.FilterRangeMax[0].To_ID_Int,
      suburbMedianRangeMin: options?.SuburbStatistics?.SuburbMedian.FilterRangeMin[0].From_ID_Int,
      suburbMedianRangeMax: options?.SuburbStatistics?.SuburbMedian.FilterRangeMax[0].To_ID_Int,
      suburbListingRangeMin: options?.SuburbStatistics?.ListingMedian.FilterRangeMin[0].From_ID_Int,
      suburbListingRangeMax: options?.SuburbStatistics?.ListingMedian.FilterRangeMax[0].To_ID_Int,
      suburbGrowthRangeMin: options?.SuburbStatistics?.YearGrowth.FilterRangeMin[0].From_ID_Int,
      suburbGrowthRangeMax: options?.SuburbStatistics?.YearGrowth.FilterRangeMax[0].To_ID_Int,
      populationMin: options?.SuburbStatistics?.Population.FilterRangeMin[0].From_ID_Int,
      populationMax: options?.SuburbStatistics?.Population.FilterRangeMax[0].To_ID_Int,
      daysOnMarketMin: options?.SuburbStatistics?.DaysOnMarket.FilterRangeMin[0].From_ID_Int,
      daysOnMarketMax: options?.SuburbStatistics?.DaysOnMarket.FilterRangeMax[0].To_ID_Int,
      vacancyRateMin: options?.SuburbStatistics?.VacancyRate.FilterRangeMin[0].From_ID_Int,
      vacancyRateMax: options?.SuburbStatistics?.VacancyRate.FilterRangeMax[0].To_ID_Int,
    };
  };

  const hasNonDefaultFilter = () => {
    const sdv: any = selectedDropdownValue;
    const defaults: any = getDefaultDropdownValues();

    if (
      !!currentState ||
      (sdv?.locationtags?.length ?? 0) > 0 ||
      (sdv?.locationBasicsSuburbs?.length ?? 0) > 0 ||
      (strategyKeywords?.length ?? 0) > 0 ||
      !!sdv?.keywordPhrases ||
      !!sdv?.excKeywordPhrases ||
      sdv?.includeLand === true
    ) {
      return true;
    }

    const isDefault =
      Object.keys(defaults).some((key) => sdv?.[key] != null && sdv[key] !== defaults[key]) && currentState == -1;
    return true;
  };

  const handleCountryChange = (e: any) => {
    if (e.value) {
      setCountry(e.value ? e.value : 1);
      setCurrentCountry(e.value == 1 ? COUNTRY.AU : COUNTRY.NZ);
      setCurrentState(null);
      selectedDropdownValue.locationtags = [];
    }
  };

  const onStateChange = (state: string) => {
    setCurrentState(state);
  };

  const handleDropdownChange = (e: any, dropdownName: any) => {
    setSelectedDropdownValue({
      ...selectedDropdownValue,
      [dropdownName]: e.value,
    });
    if (dropdownName == "keywordStrategies") {
      selectKeyWorld(undefined, e.value);
    }
  };

  const selectKeyWorld = (key: string, value: string) => {
    const defaultKeywords = options?.StrategiesCollection?.StrategiesAndKeywords?.filter((x) =>
      key ? x.Label == key : x.FilterStrategyID == value
    );
    if (defaultKeywords && defaultKeywords.length > 0) {
      setKeywords(
        (defaultKeywords[0].Keywords = defaultKeywords[0].Keywords.filter((x) => x.Label !== "Please Select..."))
      );
      setStrategyKeywords(defaultKeywords[0].Label !== OPTION_ALL ? defaultKeywords[0].Keywords : []);
    }
  };

  if (error) {
    return (
      <div className="flex items-start">
        <REIErrorMessage message={error}></REIErrorMessage>
      </div>
    );
  }

  const setLocationTag = () => {
    if (filterData?.Locality && filterData?.Locality.length > 0) {
      return filterData.Locality ? filterData.Locality.map((x) => x.Locality) : [];
    } else if (filterData?.Country?.LocationBasicsSuburbs && filterData?.Country?.LocationBasicsSuburbs.length > 0) {
      let selectedTags = [];
      if (filterData?.Country?.LocationBasicsSuburbs[0].SuburbId == "0") {
        const stateregion =
          filterData?.Country?.LocationBasics[0].Country == COUNTRY.AU
            ? AUS_MAP_DATA[filterData?.Country?.LocationBasics[0].State?.toLowerCase()]
            : NZ_MAP_DATA[filterData?.Country?.LocationBasics[0].Region?.toLowerCase()];
        if (stateregion) {
          if (filterData.Country?.LocationBasics[0].Country == COUNTRY.AU) {
            if (
              filterData.Country.LocationBasics[0].RegionId == "0" ||
              filterData.Country.LocationBasics[0].RegionId == ""
            ) {
              selectedTags.push(`${stateregion?.title}: all suburbs`);
            } else {
              selectedTags.push(`${filterData.Country.LocationBasics[0].Region}: all suburbs`);
            }
          } else if (filterData.Country?.LocationBasics[0].Country == COUNTRY.NZ) {
            if (
              filterData.Country.LocationBasics[0].DistrictId == "0" ||
              filterData.Country.LocationBasics[0].DistrictId == ""
            ) {
              selectedTags.push(`${stateregion?.title}: all suburbs`);
            } else {
              selectedTags.push(`${filterData.Country.LocationBasics[0].District}: all suburbs`);
            }
          }
        }
        return selectedTags;
      } else {
        return filterData.Country.LocationBasicsSuburbs.map((x) => x.Suburb);
      }
    }
  };

  const getLocationAdvanced = (type: string) => {
    const types: { [key: string]: number } = {
      postcodeLimit: 1,
      addressLimit: 2,
      suburbLimit: 3,
      postcodeRadius: 4,
      suburbtype: 5,
    };
    return types[type] || 1;
  };

  const initializeFormData = () => {
    const selectedData = filterData?.Country;
    if (selectedData) {
      setCountry(selectedData?.LocationBasics[0].Country == COUNTRY.AU ? 1 : 2);
      setCurrentCountry(selectedData?.LocationBasics[0].Country);

      if (selectedData.LocationBasics[0].Country == COUNTRY.AU) {
        setCurrentState(AUS_MAP_DATA[selectedData.LocationBasics[0].State?.toLowerCase()]);
      } else {
        setCurrentState(NZ_MAP_DATA[selectedData.LocationBasics[0].Region?.toLowerCase()]);
      }
    }
    setSelectedDropdownValue({
      ...selectedDropdownValue,

      locationtags: selectedData ? setLocationTag() : [],
      selectedRegion: parseInt(selectedData?.LocationBasics[0].RegionId),
      selectedDistrict: parseInt(selectedData?.LocationBasics[0].DistrictId),
      locationSearchType: getLocationAdvanced(selectedData?.LocationAdvanced[0].locationSearchType),
      locationAdanced: selectedData ? selectedData.LocationAdvanced[0] : {},
      locationBasicsSuburbs:
        selectedData?.LocationBasicsSuburbs && selectedData?.LocationBasicsSuburbs.length > 0
          ? selectedData.LocationBasicsSuburbs
          : [],
      suburbs: [],
      orderBy: selectedData ? selectedData.OrderBy : "1",

      //StrategyComponent component default values
      priceRangeMin: selectedData
        ? selectedData?.PropertySpecifics && parseInt(selectedData?.PropertySpecifics[0].priceFrom)
        : options?.PropertySpecifics && options.PropertySpecifics?.PriceRange.PriceRangeMin[0].ListingPrice_From_ID,
      priceRangeMax: selectedData
        ? parseInt(selectedData.PropertySpecifics[0].priceTo)
        : options?.PropertySpecifics?.PriceRange.PriceRangeMax[0].ListingPrice_To_ID,
      keywordStrategies: selectedData
        ? parseInt(selectedData.Strategy[0].strategyTypeId)
        : options?.Strategy?.Strategies[0].FilterStrategyID,
      keywordPhrase: selectedData
        ? parseInt(selectedData.Strategy[0].KeywordsOperandId)
        : options?.Strategy?.KeywordPhrase[0].FilterKeywordSearchTypeID,
      excKeywordPhrase: selectedData
        ? parseInt(selectedData.Strategy[0].ExcludedKeywordsOperandId)
        : options?.Strategy?.ExcKeywordPhrase[0].FilterExcludeKeywordSearchTypeID,
      keywordPhrases: selectedData ? selectedData.Strategy[0].keywords : "",
      excKeywordPhrases: selectedData ? selectedData.Strategy[0].exclude : "",

      //PropertyTypeComponent default values
      dwellingTypes: selectedData
        ? parseInt(selectedData.PropertySpecifics[0].dwellingType)
        : options?.PropertySpecifics?.DwellingTypes[0].FilterDwellingTypeID,
      bedRoomsMin: selectedData
        ? parseInt(selectedData.PropertySpecifics[0].bedRoomMin)
        : options?.PropertySpecifics?.BedRooms.BedRoomsMin[0].Bedroom_From_ID,
      bedRoomsMax: selectedData
        ? parseInt(selectedData.PropertySpecifics[0].bedRoomMax)
        : options?.PropertySpecifics?.BedRooms.BedRoomsMax[0].Bedroom_To_ID,
      bathRoomsMin: selectedData
        ? parseInt(selectedData.PropertySpecifics[0].bathRoomMin)
        : options?.PropertySpecifics?.BathRooms.BathRoomsMin[0].Bathroom_From_ID,
      bathRoomsMax: selectedData
        ? parseInt(selectedData.PropertySpecifics[0].bathRoomMax)
        : options?.PropertySpecifics?.BathRooms.BathRoomsMax[0].Bathroom_To_ID,
      carportsMin: selectedData
        ? parseInt(selectedData.PropertySpecifics[0].carPortMin)
        : options?.PropertySpecifics?.Carports.CarportsMin[0].Carport_From_ID,
      carportsMax: selectedData
        ? parseInt(selectedData.PropertySpecifics[0].carPortMax)
        : options?.PropertySpecifics?.Carports.CarportsMax[0].Carport_To_ID,
      landSizesMin: selectedData
        ? parseInt(selectedData.PropertySpecifics[0].landSizeMin)
        : options?.PropertySpecifics?.LandSizes.LandSizesMin[0].LandSize_From_ID,
      landSizesMax: selectedData
        ? parseInt(selectedData.PropertySpecifics[0].landSizeMax)
        : options?.PropertySpecifics?.LandSizes.LandSizesMax[0].LandSize_To_ID,
      listingAgeMin: selectedData
        ? parseInt(selectedData.ListingDetail[0].listingAgeMin)
        : options?.ListingDetails?.ListingAge?.ListingAgeMin[0].ListingAge_From_ID,
      listingAgeMax: selectedData
        ? parseInt(selectedData.ListingDetail[0].listingAgeMax)
        : options?.ListingDetails?.ListingAge?.ListingAgeMax[0].ListingAge_To_ID,
      propertyYieldMin: selectedData
        ? parseInt(selectedData.ListingDetail[0].propertyYieldMin)
        : options?.ListngDetails?.PropertyYields.PropertyYieldMin[0].PotentialYield_From_ID,
      propertyYieldMax: selectedData
        ? parseInt(selectedData.ListingDetail[0].propertyYieldMax)
        : options?.ListingDetails?.PropertyYields.PropertyYieldMax[0].PotentialYield_To_ID,
      includeLand: selectedData ? selectedData.PropertySpecifics[0].includeLand == "true" : false,

      // //SuburbComponent default values
      filterRangeMin: selectedData
        ? parseInt(selectedData.SuburbStatistics[0].rentalYieldMin)
        : options?.SuburbStatistics?.RentalYields.FilterRangeMin[0].From_ID_Int,
      filterRangeMax: selectedData
        ? parseInt(selectedData.SuburbStatistics[0].rentalYieldMax)
        : options?.SuburbStatistics?.RentalYields.FilterRangeMax[0].To_ID_Int,
      suburbMedianRangeMin: selectedData
        ? parseInt(selectedData.SuburbStatistics[0].suburbMedianMin)
        : options?.SuburbStatistics?.SuburbMedian.FilterRangeMin[0].From_ID_Int,
      suburbMedianRangeMax: selectedData
        ? parseInt(selectedData.SuburbStatistics[0].suburbMedianMax)
        : options?.SuburbStatistics?.SuburbMedian.FilterRangeMax[0].To_ID_Int,
      suburbListingRangeMin: selectedData
        ? parseInt(selectedData.SuburbStatistics[0].listingMedianMin)
        : options?.SuburbStatistics?.ListingMedian.FilterRangeMin[0].From_ID_Int,
      suburbListingRangeMax: selectedData
        ? parseInt(selectedData.SuburbStatistics[0].listingMedianMax)
        : options?.SuburbStatistics?.ListingMedian.FilterRangeMax[0].To_ID_Int,
      suburbGrowthRangeMin: selectedData
        ? parseInt(selectedData.SuburbStatistics[0].oneYrGrowthMin)
        : options?.SuburbStatistics?.YearGrowth.FilterRangeMin[0].From_ID_Int,
      suburbGrowthRangeMax: selectedData
        ? parseInt(selectedData.SuburbStatistics[0].oneYrGrowthMax)
        : options?.SuburbStatistics?.YearGrowth.FilterRangeMax[0].To_ID_Int,
      populationMin: selectedData
        ? parseInt(selectedData.SuburbStatistics[0].populationMin)
        : options?.SuburbStatistics?.Population.FilterRangeMin[0].From_ID_Int,
      populationMax: selectedData
        ? parseInt(selectedData.SuburbStatistics[0].populationMax)
        : options?.SuburbStatistics?.Population.FilterRangeMax[0].To_ID_Int,
      daysOnMarketMin: selectedData
        ? parseInt(selectedData.SuburbStatistics[0].daysOnMarketMin)
        : options?.SuburbStatistics?.DaysOnMarket.FilterRangeMin[0].From_ID_Int,
      daysOnMarketMax: selectedData
        ? parseInt(selectedData.SuburbStatistics[0].daysOnMarketMax)
        : options?.SuburbStatistics?.DaysOnMarket.FilterRangeMax[0].To_ID_Int,
      vacancyRateMin: selectedData
        ? parseInt(selectedData.SuburbStatistics[0].vacancyRateMin)
        : options?.SuburbStatistics?.VacancyRate.FilterRangeMin[0].From_ID_Int,
      vacancyRateMax: selectedData
        ? parseInt(selectedData.SuburbStatistics[0].vacancyRateMax)
        : options?.SuburbStatistics?.VacancyRate.FilterRangeMax[0].To_ID_Int,

      valueInitiated: true,
    });
    if (options && selectedData && selectedData.Strategy && selectedData.Strategy.length > 0) {
      const defaultKeywords = options?.StrategiesCollection?.StrategiesAndKeywords?.filter(
        (x) => x.FilterStrategyID == parseInt(selectedData.Strategy[0].strategyTypeId)
      );
      if (defaultKeywords && defaultKeywords.length > 0) {
        setKeywords(defaultKeywords[0].Keywords);
        setStrategyKeywords(defaultKeywords[0].Keywords);
      } else if (selectedData.StrategyTypeKeywords && selectedData.StrategyTypeKeywords.length > 0) {
        setStrategyKeywords(
          selectedData.StrategyTypeKeywords.map((x) => {
            return { FilterKeywordID: parseInt(x.keywordId), Label: x.keyword };
          })
        );
      }
    }
  };

  const resetFilters = () => {
    setCountry(2);
    dispatch(clearFilterValue());
    initializeFormData();
    dispatch(setLiveSearchObject(null));
    dispatch(setIsFilterApplied(false));
    setCurrentState(null);
    setIsClikedReset(true);
    setResetAllFilters(true);
    setStrategyKeywords([]);
    setLocationValidationError(false);

    setTimeout(() => {
      setCountry(1);
      setResetAllFilters(false);
    }, 100);
  };

  const getLabel = (optiondata: [], keyWordId: string, id: number, label: string) => {
    const data = optiondata && optiondata.length > 0 && optiondata.find((x) => x[keyWordId] == id);
    if (data) {
      return data[label];
    }
    return "";
  };

  const getLocationTypeById = (number: number): string => {
    const types: { [key: string]: number } = {
      postcodeLimit: 1,
      addressLimit: 2,
      suburbLimit: 3,
      postcodeRadius: 4,
      suburbtype: 5,
    };

    for (const key in types) {
      if (types[key] === number) {
        return key;
      }
    }
    return "";
  };

  const getLocationSuburb = () => {
    const suburbList: any[] = selectedDropdownValue?.locationBasicsSuburbs ?? [];

    const getSuburbName = (item: any) => (typeof item === "string" ? item : item?.Suburb);

    if (suburbList.length > 0 && suburbList.some((x) => getSuburbName(x)?.includes("all suburbs"))) {
      return [
        {
          SuburbId: "0",
          Suburb: getSuburbName(suburbList[0]),
        },
      ];
    } else {
      return suburbList.map((item) => {
        if (typeof item !== "string") {
          return { SuburbId: item?.SuburbId, Suburb: item?.Suburb };
        }
        return {
          SuburbId: selectedDropdownValue?.suburbs?.find((x) => x.Label == item)?.FilterSuburbID,
          Suburb: item,
        };
      });
    }
  };

  const getRegionDistrictName = (stateid: number, id: number) => {
    if (currentCountry == COUNTRY.AU) {
      const data = options?.LocationBasicAUCollection?.State?.find((state: any) => state.FilterStateID === stateid);
      if (data) {
        return data.Regions.find((x) => x.FilterRegionID === id);
      }
    } else {
      const data = options?.LocationBasicNZCollection?.Regions?.find(
        (district: any) => district.FilterRegionID === stateid
      );
      if (data) {
        return data.Districts.find((x) => x.FilterDistrictID === id);
      }
    }
  };

  const getLocality = () => {
    let locality: { Locality: string }[] = [];
    if (
      selectedDropdownValue?.locationBasicsSuburbs &&
      selectedDropdownValue?.locationBasicsSuburbs.length > 0
    ) {
      locality = selectedDropdownValue.locationBasicsSuburbs
        .filter((x) => x?.SuburbId != "0")
        .map((x) => ({ Locality: x }));
    }
    return locality;
  };

  const getSearchObject = async () => {
    let savedSearchData = {
      Country: {
        MemberID: localStorage.getItem("member_id"),
        Limit: "200",
        Title: "",
        OrderBy: selectedDropdownValue.orderBy,
        CountryCode: currentCountry,
        Strategy: [
          {
            strategyTypeId: selectedDropdownValue.keywordStrategies,
            strategyType: getLabel(
              options?.StrategiesCollection?.StrategiesAndKeywords,
              "FilterStrategyID",
              selectedDropdownValue.keywordStrategies || 0,
              "Label"
            ),
            keywords: selectedDropdownValue?.keywordPhrases,
            KeywordsOperand: getLabel(
              options?.Strategy?.KeywordPhrase,
              "FilterKeywordSearchTypeID",
              selectedDropdownValue?.keywordPhrase || 0,
              "Label"
            ),
            KeywordsOperandId: selectedDropdownValue?.keywordPhrase,
            exclude: selectedDropdownValue?.excKeywordPhrases,
            ExcludedKeywordsOperand: getLabel(
              options?.Strategy?.ExcKeywordPhrase,
              "FilterExcludeKeywordSearchTypeID",
              selectedDropdownValue?.excKeywordPhrase || 0,
              "Label"
            ),
            ExcludedKeywordsOperandId: selectedDropdownValue?.excKeywordPhrase,
          },
        ],
        StrategyTypeKeywords: strategyKeywords.map((x) => {
          return { keywordId: x.FilterKeywordID, keyword: x.Label };
        }),
        PropertySpecifics: [
          {
            dwellingType: selectedDropdownValue?.dwellingTypes?.toString() || "9",
            includeLand: selectedDropdownValue?.includeLand ? "true" : "false",
            priceFrom: selectedDropdownValue?.priceRangeMin?.toString() ?? "37",
            priceTo: selectedDropdownValue?.priceRangeMax?.toString() ?? "37",
            bedRoomMin: selectedDropdownValue?.bedRoomsMin?.toString() ?? "6",
            bedRoomMax: selectedDropdownValue?.bedRoomsMax?.toString() ?? "7",
            bathRoomMin: selectedDropdownValue?.bathRoomsMin?.toString() ?? "6",
            bathRoomMax: selectedDropdownValue?.bathRoomsMax?.toString() ?? "7",
            carPortMin: selectedDropdownValue?.carportsMin?.toString() ?? "6",
            carPortMax: selectedDropdownValue?.carportsMax?.toString() ?? "7",
            landSizeMin: selectedDropdownValue?.landSizesMin?.toString() ?? "19",
            landSizeMax: selectedDropdownValue?.landSizesMax?.toString() ?? "20",
          },
        ],
        LocationAdvanced: [
          {
            locationSearchType: getLocationTypeById(selectedDropdownValue?.locationSearchType || 1),
            limitPostcode:
              selectedDropdownValue?.locationSearchType == LOCATION_ADVANCED.POSTCODE_LIMIT
                ? selectedDropdownValue.locationAdanced.limitPostcode != ""
                  ? selectedDropdownValue.locationAdanced?.limitPostcode?.toString()
                  : options?.LocationAdvanced[0]?.limitPostcode
                : "",
            limitStreet:
              selectedDropdownValue?.locationSearchType == LOCATION_ADVANCED.ADDRESS_LIMIT
                ? selectedDropdownValue.locationAdanced.limitStreet != ""
                  ? selectedDropdownValue.locationAdanced?.limitStreet?.toString()
                  : options?.LocationAdvanced[0]?.limitStreet
                : "",
            limitSuburb:
              selectedDropdownValue?.locationSearchType == LOCATION_ADVANCED.SUBURB_LIMIT &&
              currentCountry == COUNTRY.AU
                ? selectedDropdownValue.locationAdanced.limitSuburb != ""
                  ? selectedDropdownValue.locationAdanced?.limitSuburb?.toString()
                  : options?.LocationAdvanced[0]?.limitSuburb
                : "",
            postcodeRadiusFrom:
              selectedDropdownValue?.locationSearchType == LOCATION_ADVANCED.POSTCODE_RADIUS
                ? selectedDropdownValue?.postcodeRadiusFrom
                : "",
            postcodeRadiusTo:
              selectedDropdownValue?.locationSearchType == LOCATION_ADVANCED.POSTCODE_RADIUS
                ? selectedDropdownValue?.postcodeRadiusTo
                : "",
            ofPostcode:
              selectedDropdownValue?.locationSearchType == LOCATION_ADVANCED.POSTCODE_RADIUS
                ? selectedDropdownValue.locationAdanced.ofPostcode
                : "",
            suburbRadiusFrom:
              selectedDropdownValue?.locationSearchType == LOCATION_ADVANCED.SUBURB_LIMIT
                ? selectedDropdownValue?.suburbRadiusFrom
                : "",
            suburbRadiusTo:
              selectedDropdownValue?.locationSearchType == LOCATION_ADVANCED.SUBURB_LIMIT
                ? selectedDropdownValue?.suburbRadiusTo
                : "",
            OflimitSuburb:
              selectedDropdownValue?.locationSearchType == LOCATION_ADVANCED.SUBURB_LIMIT
                ? selectedDropdownValue.locationAdanced.OflimitSuburb
                : "",
            selectedSuburbType:
              selectedDropdownValue?.locationSearchType == LOCATION_ADVANCED.SUBURB_TYPE
                ? selectedDropdownValue.locationAdanced.selectedSuburbType
                : "",
          },
        ],
        LocationBasicsSuburbs: currentState ? getLocationSuburb() : [],
        SuburbStatistics: [
          {
            suburbMedianMin: selectedDropdownValue?.suburbMedianRangeMin?.toString() ?? "29",
            suburbMedianMax: selectedDropdownValue?.suburbMedianRangeMax?.toString() ?? "29",
            vacancyRateMin: selectedDropdownValue?.vacancyRateMin?.toString() ?? "15",
            vacancyRateMax: selectedDropdownValue?.vacancyRateMax?.toString() ?? "16",
            listingMedianMin: selectedDropdownValue?.suburbListingRangeMin?.toString() ?? "18",
            listingMedianMax: selectedDropdownValue?.suburbListingRangeMax?.toString() ?? "19",
            rentalYieldMin: selectedDropdownValue?.filterRangeMin?.toString() ?? "22",
            rentalYieldMax: selectedDropdownValue?.filterRangeMax?.toString() ?? "23",
            oneYrGrowthMin: selectedDropdownValue?.suburbGrowthRangeMin?.toString() ?? "16",
            oneYrGrowthMax: selectedDropdownValue?.suburbGrowthRangeMax?.toString() ?? "17",
            populationMin: selectedDropdownValue?.populationMin?.toString() ?? "18",
            populationMax: selectedDropdownValue?.populationMax?.toString() ?? "19",
            daysOnMarketMin: selectedDropdownValue?.daysOnMarketMin?.toString() ?? "7",
            daysOnMarketMax: selectedDropdownValue?.daysOnMarketMax?.toString() ?? "8",
          },
        ],
        ListingDetail: [
          {
            propertyYieldMin: selectedDropdownValue?.propertyYieldMin?.toString() ?? "12",
            propertyYieldMax: selectedDropdownValue?.propertyYieldMax?.toString() ?? "13",
            listingAgeMin: selectedDropdownValue?.listingAgeMin?.toString() ?? "17",
            listingAgeMax: selectedDropdownValue?.listingAgeMax?.toString() ?? "13",
            showDuplicates: "false",
          },
        ],
        LocationBasics: [
          {
            Country: currentCountry,
            StateId: currentCountry == COUNTRY.AU ? currentState?.id : "",
            State: currentCountry == COUNTRY.AU ? currentState?.title : "",
            Region:
              currentCountry != COUNTRY.AU
                ? currentState?.title
                : selectedDropdownValue?.selectedRegion == "0"
                  ? OPTION_ALL
                  : getRegionDistrictName(currentState?.id, selectedDropdownValue?.selectedRegion)?.Label,
            RegionId: currentCountry != COUNTRY.AU ? currentState?.id : selectedDropdownValue?.selectedRegion,
            DistrictId: currentCountry != COUNTRY.AU ? selectedDropdownValue?.selectedDistrict : "",
            District:
              currentCountry != COUNTRY.AU
                ? selectedDropdownValue?.selectedDistrict == "0"
                  ? OPTION_ALL
                  : getRegionDistrictName(currentState?.id, selectedDropdownValue?.selectedDistrict)?.Label
                : "",
          },
        ],
      },
      Locality: !currentState ? getLocality() : [],
    };

    const strategyKeywordsobject = options?.StrategiesCollection?.StrategiesAndKeywords.find(
      (x) => x.FilterStrategyID == selectedDropdownValue.keywordStrategies
    );
    if (
      strategyKeywordsobject?.Label &&
      strategyKeywordsobject?.Label == OPTION_ALL &&
      strategyKeywordsobject?.Keywords.length == strategyKeywords.length
    ) {
      savedSearchData.Country.StrategyTypeKeywords = [];
    }
    return savedSearchData;
  };

  const searchResult = async () => {
    if (locationValidationError) {
      return;
    }

    setLoading(true);
    setSearchLoading();

    const search = await getSearchObject();

    dispatch(setIsFilterApplied(true));

    dispatch(setLiveSearchObject(search));

    await httpPost(`${ApiEndPoints.searchSummary}/${currentCountry}/Search/Summary/`, search)
      .then((result) => {
        if (result.status == 200) {
          handleSearchClick(result.data, search);
          setShowMap(false);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const handleLocationValidation = (isValid: boolean) => {
    setLocationValidationError(!isValid);
  };

  const hideSaveThisSearch = useCallback(() => {
    setShowSaveThisSearch(false);
    dispatch(
      updateSearchState({
        searchData: searchData,
      })
    );
  }, [searchData, dispatch]);

  const openSaveThisSearch = async () => {
    const searchobject = await getSearchObject();
    setSearchData(searchobject);
    setShowSaveThisSearch(true);
  };
  return (
    <>
      {options && selectedDropdownValue && (
        <REIDialoge
          showHeader={true}
          header={`Save this search`}
          visible={showSaveThisSearch}
          handleEditClick={hideSaveThisSearch}
          position="top"
          style={{ width: "60vw" }}
          customClass="save-this-search"
          contentComponent={<SaveThisSearch closeDialog={hideSaveThisSearch} savesearch={searchData} />}
        ></REIDialoge>
      )}
      <div className="flex flex-col">
        <div className="flex-1 border border-gray-300">
          <div
            className={classNames(
              "flex",
              searchOnlyScreen ? "lg:flex-nowrap md:flex-wrap flex-wrap" : "flex-wrap",
              "gap-1"
            )}
          >
            <div className={searchOnlyScreen ? "lg:w-[40%] w-full" : "w-full"}>
              <div className="flex flex-row lg:justify-between w-full gap-1">
                <div className="flex-0 w-7/12 text-start">
                  {(searchOnlyScreen || showMap) && (
                    <REISelectButton
                      id="srch-sbtn-country"
                      label="name"
                      value={country}
                      onChange={handleCountryChange}
                      items={COUNTRY_OPTIONS}
                    ></REISelectButton>
                  )}
                </div>
                {!searchOnlyScreen && (
                  <div className="flex w-full items-center justify-end gap-2 max-sm:flex-col max-sm:items-stretch">
                    <REIButton
                      id="srch-btn-maptoggle"
                      label=""
                      disabled={false}
                      loading={false}
                      icon="pi pi-map"
                      tooltip={showMap ? "Hide Map" : "Show Map"}
                      classNames="max-sm:w-full"
                      onClick={() => {
                        !searchOnlyScreen ? setShowMap(!showMap) : setShowMap(false);
                      }}
                    />
                    <REIButton
                      id="srch-btn-clearfilters"
                      label="Clear filters"
                      disabled={false}
                      icon="pi pi-refresh"
                      loading={false}
                      classNames="whitespace-nowrap  max-sm:w-full"
                      onClick={() => {
                        resetFilters();
                      }}
                    />
                  </div>
                )}
              </div>
              {(searchOnlyScreen || showMap) && (
                <div className="flex flex-col lg:flex-row lg:w-full gap-1">
                  <div className="flex-0 w-full pt-5 align-center-vl">
                    {country === 1 && (
                      <AustraliaMap
                        currentstate={!currentState ? -1 : parseInt(filterData?.Country?.LocationBasics[0].StateId)}
                        onStateChange={onStateChange}
                      />
                    )}
                    {country !== 1 && (
                      <NewZealandMap
                        region={!currentState ? -1 : parseInt(filterData?.Country?.LocationBasics[0].RegionId)}
                        onStateChange={onStateChange}
                      />
                    )}
                  </div>
                </div>
              )}
            </div>

            <div className={searchOnlyScreen ? "lg:w-[60%] w-full" : "w-full"}>
              {options && (
                <div className="edit-saved-search">
                  <LocationComponent
                    selectedState={currentState}
                    optionsdata={options}
                    selectedDropdownValue={selectedDropdownValue}
                    handleDropdownChange={handleDropdownChange}
                    country={currentCountry}
                    showMapOptions={searchOnlyScreen || showMap}
                    resetFilters={resetAllFilters}
                    onValidationChange={handleLocationValidation}
                  />
                  <REIDivider />
                  <StrategyComponent
                    selectedDropdownValue={selectedDropdownValue}
                    handleDropdownChange={handleDropdownChange}
                    optionsdata={options}
                    strategyKeywords={strategyKeywords}
                    strategyOnChange={(e) => setStrategyKeywords(e.value)}
                    keywords={keywords}
                    resetAllFilters={resetAllFilters}
                  ></StrategyComponent>
                  <REIDivider />
                  <PropertyTypeComponent
                    selectedDropdownValue={selectedDropdownValue}
                    handleDropdownChange={handleDropdownChange}
                    optionsdata={options}
                    searchOnlyScreen={searchOnlyScreen}
                    resetAllFilters={resetAllFilters}
                    country={currentCountry}
                  ></PropertyTypeComponent>
                  <REIDivider />
                  <SuburbComponent
                    selectedDropdownValue={selectedDropdownValue}
                    handleDropdownChange={handleDropdownChange}
                    optionsdata={options}
                    resetAllFilters={resetAllFilters}
                    searchOnlyScreen={searchOnlyScreen}
                    country={currentCountry}
                  ></SuburbComponent>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="border-solid border border-x-0 border-b-0 border-gray-300 min-h-16 p-2">
          <div className="flex flex-wrap gap-1 justify-end max-sm:flex-wrap-reverse">
            <REIButton
              label="Search"
              icon="pi pi-search"
              disabled={false}
              loading={loading}
              classNames={"max-sm:w-full"}
              onClick={() => searchResult()}
            />
            {searchOnlyScreen && (
              <REIButton
                id="srch-btn-clearfilters"
                label="Clear filters"
                disabled={false}
                icon="pi pi-refresh"
                loading={false}
                classNames="whitespace-nowrap  max-sm:w-full"
                onClick={() => {
                  resetFilters();
                }}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default SearchDetail;
